import React from "react";

function Facebook() {
  return (
    <svg
      id="Group_26073"
      data-name="Group 26073"
      xmlns="http://www.w3.org/2000/svg"
      width="56"
      height="56"
      viewBox="0 0 56 56"
    >
      <path
        id="Path_18417"
        data-name="Path 18417"
        d="M56,28.171A28.126,28.126,0,0,1,32.375,56V36.314H38.9l1.241-8.143H32.375V22.887c0-2.228,1.085-4.4,4.563-4.4h3.531V11.555A42.814,42.814,0,0,0,34.2,11c-6.4,0-10.575,3.9-10.575,10.96v6.206H16.516v8.143h7.109V56A28.159,28.159,0,1,1,56,28.171Z"
        fill="#1877f2"
      />
    </svg>
  );
}

export default Facebook;
